<template>
    <div class=" flex items-center justify-between gap-2 w-full h-full py-4 px-3 rounded-xl shadow-lg" :class="className" :style="{ backgroundColor: backgroundColor }">
        <div class=" flex items-start gap-2"  >
            <icon :icon-name="icon" size="xsm" />
            <div class="space-y-[2px]">
                <p class=" text-xs uppercase font-black text-romanSilver">{{ title }}</p>
                <p class="font-bold text-base">
                    <slot name="value">{{ value }}</slot>
                </p>
            </div>
        </div>
        <div v-if="showSecondaryContent" style="width: 1px" class="h-full bg-romanSilver"></div>
        <div v-if="showSecondaryContent" class="space-y-[2px]">
            <p class=" text-xs uppercase font-black text-romanSilver">{{ secondaryTitle }}</p>
            <p class="font-bold text-base">
                <slot name="secondaryValue">{{ secondaryValue }}</slot>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "DashboardCard",
    components: {},
    props: {
        title: {
            type: String,
            required: true
        },
        value: {
            type: [String, Number],
            default: ''
        },
        showSecondaryContent: {
            type: Boolean,
            default: false
        },
        secondaryTitle: {
            type: String,
            default: ''
        },
        secondaryValue: {
            type: [String, Number],
            default: ''
        },
        loading: {
            type: Boolean,
            default: false
        },
        icon: {
            type: String,
            default: null
        },
        backgroundColor: {
            type: String,
            default: '#ffffff'
        },
        className: {
            type: [String, Array, Object],
            default: ''
        }
    }
}
</script>

<style lang="scss" scoped>

</style>